import { useEffect, useRef, useState } from "react";
import DefaultImage from "../../assets/png/defaultImage.png";
import { BsCartPlus } from "react-icons/bs";
import { FaRegEye } from "react-icons/fa6";
import { FaRegHeart } from "react-icons/fa";
import { Rating } from "react-simple-star-rating";
import { useNavigate } from "react-router-dom";
import { dispatch } from "../../redux/store";
import { saveFavorite } from "../../redux/slices/favorite/favoriteSlice";
import { Modal } from "../shared/Modal";
import ProductDetailsModal from "./ProductDetailsModal";
import { HiOutlineShoppingBag } from "react-icons/hi2";

interface SpecialProductCardProps {
  product: any;
}

const SpecialProductCard = ({ product }: SpecialProductCardProps) => {
  const navigation = useNavigate();
  const [isClicked, setIsClicked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (cardRef.current && !cardRef.current.contains(event.target as Node)) {
        setIsClicked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={cardRef}
      onClick={() => setIsClicked(!isClicked)}
      className={`w-full flex gap-2 p-1 h-24 cursor-pointer hover:shadow-custom hover:shadow-[#05A30D] border ${
        isClicked && "border-[#05A30D]"
      } rounded-md relative`}
    >
      <div className="aspect-square h-full flex justify-center object-center">
        <img
          src={product?.images?.length > 0 ? product?.images[0] : DefaultImage}
          alt="img"
          className="h-full object-contain object-center rounded-md"
        />
      </div>

      <div className="flex-grow flex flex-col justify-center gap-[2px] px-2 py-2 overflow-hidden">
        <div
          className={`text-sm text-[#4D4D4D] flex-grow ${
            isClicked ? "text-xs content-center" : "truncate"
          }`}
        >
          {product?.name}
        </div>
        <div className="flex-grow relative">
          <div className="w-full flex flex-col">
            {product?.sellingPriceWithTax ? (
              <div className="font-semibold">
                £{product?.sellingPriceWithTax.toFixed(2)}
              </div>
            ) : (
              <div className="font-semibold text-sm">N/A</div>
            )}
            <div>
              <Rating
                allowFraction
                initialValue={product?.avgProductRating}
                readonly
                size={10}
                fillColor="#FF8A00"
                emptyColor="#ccc"
                SVGclassName="inline-block"
              />
            </div>
          </div>

          <div
            className={`absolute top-0 flex items-center justify-center gap-1 right-0 flex-grow h-full w-full bg-white transition-transform duration-300 ease-in-out ${
              isClicked ? "translate-x-0" : "translate-x-full scale-x-0"
            }`}
          >
            <div
              onClick={(e) => {
                e.stopPropagation();
                setIsModalOpen(true);
              }}
              className={`rounded-full cursor-pointer hover:bg-[#05A30D] hover:text-white mr-2 border-[1px] p-1 self-center transition-all hover:scale-125 hover:opacity-80 shadow-custom flex items-center justify-center aspect-square h-9 w-9 ml-[2px]`}
            >
              <HiOutlineShoppingBag />
            </div>
            <div
              onClick={() => navigation(`/product/${product?.id}`)}
              className={`rounded-full cursor-pointer hover:bg-[#05A30D] hover:text-white mr-2 border-[1px] p-1 self-center transition-all hover:scale-125 hover:opacity-80 shadow-custom flex items-center justify-center aspect-square h-9 w-9 ml-[2px]`}
            >
              <FaRegEye />
            </div>
            <div
              onClick={(e) => {
                e.stopPropagation();
                dispatch(
                  saveFavorite({
                    productId: product?.id,
                  })
                );
              }}
              className={`rounded-full cursor-pointer hover:bg-[#05A30D] hover:text-white mr-2 border-[1px] p-1 self-center transition-all hover:scale-125 hover:opacity-80 shadow-custom flex items-center justify-center aspect-square h-9 w-9 ml-[2px]`}
            >
              <FaRegHeart />
            </div>
          </div>
        </div>

        {/* Sliding Div */}
      </div>
      <Modal
        isOpen={isModalOpen}
        setISOpen={setIsModalOpen}
        title={`Add ${product?.name} to cart`}
        content={
          <ProductDetailsModal
            isModalOpen={isModalOpen}
            image={product?.images}
            home
            id={product?.id}
            setIsModalOpen={setIsModalOpen}
          />
        }
      />
    </div>
  );
};

export default SpecialProductCard;
